import React from 'react';
import { WebsiteDesignProps } from './types';
import { Microscope, Atom, Dna, ArrowUpRight } from 'lucide-react';

const InnovationLab: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Eureka Institute";

    return (
        <div className="bg-white text-black min-h-screen font-mono">
            {/* Grid Lines Overlay */}
            <div className="fixed inset-0 pointer-events-none z-0" style={{ 
                backgroundImage: 'linear-gradient(#eee 1px, transparent 1px), linear-gradient(90deg, #eee 1px, transparent 1px)', 
                backgroundSize: '50px 50px' 
            }}></div>

            <header className="relative z-10 p-8 flex justify-between items-end border-b border-black">
                <h1 className="text-5xl font-bold tracking-tighter leading-none">
                    {schoolName} <span className="text-xs align-top bg-black text-white px-1">BETA</span>
                </h1>
                <div className="hidden md:block text-right">
                     <div className="text-xs">LAT: 40.7128° N</div>
                     <div className="text-xs">LON: 74.0060° W</div>
                </div>
            </header>

            <main className="relative z-10 container mx-auto px-8 py-20">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-8">
                        <h2 className="text-8xl font-medium tracking-tighter mb-12">
                            WE <br/> SOLVE <br/> X.
                        </h2>
                        <div className="border border-black p-8 max-w-xl bg-white shadow-[10px_10px_0px_0px_rgba(0,0,0,1)]">
                            <p className="text-lg mb-6">
                                An intensive research institute for young scientists and engineers. We don't just study history; we invent the future.
                            </p>
                            <button className="w-full bg-black text-white py-4 font-bold hover:bg-gray-800 flex justify-between px-6">
                                APPLY_NOW() <ArrowUpRight />
                            </button>
                        </div>
                    </div>
                    
                    <div className="lg:col-span-4 flex flex-col gap-4">
                        {[
                            { icon: Atom, label: "Physics" },
                            { icon: Dna, label: "Biotech" },
                            { icon: Microscope, label: "Research" }
                        ].map((field, i) => (
                            <div key={i} className="flex-1 bg-gray-50 border border-black p-6 flex items-center justify-between hover:bg-black hover:text-white transition-colors cursor-pointer group">
                                <span className="text-2xl font-bold">{field.label}</span>
                                <field.icon size={32} className="group-hover:rotate-180 transition-transform duration-500" />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-24 border-t border-black pt-8 flex gap-12 overflow-x-auto pb-4">
                     <img src="https://images.unsplash.com/photo-1532094349884-543bc11b234d?q=80&w=2070&auto=format&fit=crop" className="h-64 border border-black grayscale hover:grayscale-0 transition-all" alt="" />
                     <img src="https://images.unsplash.com/photo-1581093458791-9f3c3900df4b?q=80&w=2070&auto=format&fit=crop" className="h-64 border border-black grayscale hover:grayscale-0 transition-all" alt="" />
                     <img src="https://images.unsplash.com/photo-1576086213369-97a306d36557?q=80&w=2080&auto=format&fit=crop" className="h-64 border border-black grayscale hover:grayscale-0 transition-all" alt="" />
                </div>
            </main>
        </div>
    );
};

export default InnovationLab;
